export const getNotifications = (payload?: number) => ({
  type: "@saga/GET_NOTIFICATIONS",
  payload,
});
